import { Inject, Injectable } from '@angular/core';
import { DateFnsAdapter } from '@angular/material-date-fns-adapter';
import { DateUtil } from '@core/services/date/date.util';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { Locale } from 'date-fns/locale/types';
import { subHours } from 'date-fns';

@Injectable()
export class UTCDateAdapter extends DateFnsAdapter {
  constructor(@Inject(MAT_DATE_LOCALE) private readonly _adapter: Locale) {
    super(_adapter);
  }
  public override parse(value: unknown, parseFormat: string | string[]): Date | null {
    const parse: Date | null = super.parse(value, parseFormat);
    if (parse) {
      return subHours(parse, -12 + DateUtil.timeZoneDifference(parse) / 60);
    }
    return null;
  }
  public override getFirstDayOfWeek(): number {
    return 1;
  }
  public override today(): Date {
    return DateUtil.todayUTC();
  }

  public override createDate(year: number, month: number, date: number): Date {
    if (month < 0 || month > 11) {
      throw Error(`Invalid month index "${month}". Month index has to be between 0 and 11.`);
    }

    if (date < 1) {
      throw Error(`Invalid date "${date}". Date has to be greater than 0.`);
    }
    const result = new Date();
    result.setUTCFullYear(year, month, date);
    result.setUTCHours(12, 0, 0, 0);
    // Check that the date wasn't above the upper bound for the month, causing the month to overflow
    if (result.getMonth() != month) {
      throw Error(`Invalid date "${date}" for month with index "${month}".`);
    }
    return result;
  }
}
